import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { UIButtonMode } from "./ui-button-mode.enum";
import { UITextMode } from "../ui-text/ui-text-mode.enum";

@Component({
    selector: 'ui-button',
    templateUrl: './ui-button.component.html'
})
export class UIButtonComponent {
    @Input() mode: UITextMode | UIButtonMode = UITextMode.default;
    @Input() size: 'small' | 'medium' | 'large';
    @Input() disabled: boolean = false;
    @Input() loading: boolean = false;
    @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter();
    readonly UITextMode = UITextMode;

    @ViewChild('button') button: ElementRef<HTMLButtonElement>;

    classes = {
        default: '≈bg-secondary-actions-default hover:≈bg-secondary-actions-hovered ≈border-neutral-borders-subdued active:hover:≈bg-secondary-actions-depressed active:hover:≈border-depressed-border ≈text-default-text disabled:≈bg-secondary-actions-disabled',
        warning: '≈bg-warning-surface-subdued-default hover:≈bg-warning-surface-subdued-hovered active:hover:≈bg-warning-text ≈border-warning-borders-subdued active:hover:≈border-warning-borders-default ≈text-warning-text disabled:≈bg-primary-actions-disabled',
        critical: '≈bg-critical-surface-subdued-default hover:≈bg-critical-surface-subdued-hovered active:hover:≈bg-critical-text ≈border-critical-borders-subdued-default active:hover:≈border-critical-borders-default ≈text-critical-text disabled:≈bg-primary-actions-disabled',
        success: '≈bg-success-surface-subdued-default hover:≈bg-success-surface-subdued-hovered active:hover:≈bg-success-text border-success-borders-subdued active:hover:≈border-success-borders-default ≈text-success-text disabled:≈bg-primary-actions-disabled',
        primary: '≈bg-primary-surface-selected hover:≈bg-primary-surface-hovered active:hover:≈bg-primary-actions-default ≈border-primary-surface-hovered active:hover:≈border-focused-default ≈text-primary-actions-default disabled:≈bg-primary-actions-disabled',
        highlight: '≈bg-highlight-surface-subdued-default hover:≈bg-highlight-surface-subdued-hovered active:hover:≈bg-highlight-surface-default ≈border-highlight-borders-subdued active:hover:≈border-highlight-borders-default ≈text-highlight-text disabled:≈bg-primary-actions-disabled',
        small: '≈px-1.5 ≈py-0.5 md:≈px-2 md:≈py-1 lg:≈px-2.5 lg:≈py-1.5',
        medium: '≈px-2 ≈py-1 md:≈px-2.5 md:≈py-1.5 lg:≈px-3 lg:≈py-2',
        large: '≈px-2.5 ≈py-1.5 md:≈px-3 md:≈py-2 lg:≈px-3.5 lg:≈py-2.5'
    };

    get ngClass(): { [key: string]: boolean; } {
        return {
            [this.classes.default]: this.modeIs(UIButtonMode.default),
            [this.classes.warning]: this.modeIs(UIButtonMode.warning),
            [this.classes.critical]: this.modeIs(UIButtonMode.critical),
            [this.classes.success]: this.modeIs(UIButtonMode.success),
            [this.classes.primary]: this.modeIs(UIButtonMode.primary),
            [this.classes.highlight]: this.modeIs(UIButtonMode.highlight),
            [this.classes.small]: this.size == 'small',
            [this.classes.medium]: this.size == 'medium' || !this.size,
            [this.classes.large]: this.size == 'large',
            '≈flex ≈items-center ≈justify-center ≈cursor-wait ≈pointer-events-none': this.loading,
            '≈cursor-pointer': !this.loading
        };
    }

    modeIs(mode: UIButtonMode | string): boolean {
        return mode == this.mode || mode == UIButtonMode[this.mode];
    }

    click(event: Event): void {
        if (this.loading)
            return;
        this.onClick.emit(event as MouseEvent);
    }

    get elementRef(): HTMLButtonElement {
        return this.button?.nativeElement;
    }
}